import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { useDispatch } from "react-redux";
// import { userSignIn } from "../../../../redux/user/userActions";
import { LoginSchema } from "../../../../utils/validationsSchema";
import {
  Form,
  CustomTextField,
  SubmitButton,
} from "../../../../utils/formGenerator";
import { useRegisterState } from "../../../components/contexts/authContext/AuthContextProvider";
import Step1 from "./components/Step1";
import Step2 from "./components/Step2";

const Login = ({ history }) => {
  let template = null;
  const state = useRegisterState();
  switch (state.step) { 
    case 1:
      template = <Step1 />;
      break;
    case 2:
      template = <Step2 />;
      break;
    default:
      template = null;
  }

  return (
    <div className="login-form login-signin" id="kt_login_signin_form">
      {/* begin::Head */}
      <div className="text-center mb-10 mb-lg-20">
        <h3
          className="font-size-h6"
          style={{
            fontSize: "14px",
          }}
        >
          پنل فروش انبوه صنایع دستی آقاجانی
        </h3>
      </div>

      {template}
    </div>
  );
};

export default withRouter(Login);
